var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-del icon-close otz-icon no-bg",on:{"click":function($event){$event.stopPropagation();return _vm.remove()}}},[_vm._v("F")])}
var staticRenderFns = []

export { render, staticRenderFns }